import React, { useState, useCallback } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing } from 'devextreme-react/data-grid';

import { withLoadPanel } from '../../../utils/withLoadPanel';


import './CardSessions.scss';
import { checkPermission } from '../../../permissions';

const Grid = ({ sessions, competitionId }) => {
    const [gridData, setGridData] = useState(sessions);
    const handleInitNewRow = (e) => {
        e.data.competitionId = competitionId;
      };
    
    return (
        <DataGrid
            className='sessions-grid'
            dataSource={gridData}
            remoteOperations={true}
            columnAutoWidth
            onInitNewRow={handleInitNewRow}
            height={'calc(100vh - 210px)'}
        >
            <Editing allowUpdating={checkPermission("competition.edit")} allowAdding={checkPermission("competition.edit")} allowDeleting={checkPermission("competition.edit")} />


            <Column
                dataField='number'
                caption='Nummer'
                hidingPriority={3}
                sortOrder='asc'
                sortIndex={0}
            />
            <Column
                dataField='name'
                caption='Name'
                hidingPriority={3}
            />
            <Column
                dataField='startdate'
                dataType='datetime'
                caption='Beginn'
                hidingPriority={1}
            />
            <Column
                dataField='teamleadermeeting'
                dataType='datetime'
                caption='Mannschaftsleitersitzung'
                hidingPriority={3}
            />
            <Column
                dataField='warmupfrom'
                dataType='datetime'
                caption='Einschwimmen ab'
                hidingPriority={3}
            />

        </DataGrid>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardSessions = ({ sessions, competitionId, isLoading }) => {
    return (
        <div className='card-sessions'>
            <GridWithLoadPanel
                sessions={sessions}
                hasData={!!sessions}
                loading={isLoading}
                competitionId={competitionId}
                panelProps={{
                    container: '.card-sessions',
                    position: { of: '.card-sessions' }
                }}
            />
        </div>
    );
};
